// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import store from './store'
import axios from 'axios'

import getData from './assets/js/getData'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import './assets/css/global.css'

import 'vue2-toast/lib/toast.css'
import Toast from 'vue2-toast'
import {APPID} from './config/config'

import dialog from '@/base/dialog/index.js'

Vue.use(dialog)

Vue.use(Toast, {
  defaultType: 'top',
  duration: 2000,
  wordWrap: true,
  width: '150px'
})

Vue.use(VueResource);
Vue.use(getData);
Vue.use(ElementUI);

Vue.config.productionTip = false

window.grobalVue = Vue;

/* 创建首次链接之后进行Vue渲染， 避免并发造成PHPSESSID混乱错误 */
function vueRender(){
  function initVue() {
      /* 等待外部JS加载完毕 */
      if (window.customassetsload) {
        window.v = new Vue({
          el: '#app',
          router,
          store,
          template: '<App/>',
          components: { App }
        })
      }else{
        window.v = new Vue({
          el: '#app',
          router,
          store,
          template: '<App/>',
          components: { App }
        })
      }
  }
  axios({
    url: '/activity/api.php?m=public&subm=front'
  }).then(() => {
      initVue();
  }).catch(() => {
      initVue();
  })
}

var zjrbCp = document.createElement('script')
zjrbCp.src = 'https://cdn-cp.tmuyun.com/jssdk/delta/zjrb-cp.delta.min.js'
document.body.appendChild(zjrbCp)
zjrbCp.onload = function() {
  if (CP && typeof CP.ready === 'function') {
    CP.ready({
      debug: false,
      wx_option: {
        debug: false,
        appid: APPID,
        method: 'getShareSign',
        redirect: location.href.split('#')[0],
        jsApiList: [
          'onMenuShareTimeline', 'onMenuShareAppMessage', 'getLocation', 'updateAppMessageShareData', 'updateTimelineShareData'
        ],
      },
      ready: function(res) {
        sessionStorage.setItem('isClient', res.is_client)
        vueRender()
      },
      error: function(error) {
        sessionStorage.setItem('isClient', error.client.is_client)
        if (error && error.code === 104) {
          vueRender()
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/main.js